import React, {useState, useRef} from 'react'
import {useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import OutpatientPage from './OutpatientPage'
import PatientPage from './PatientPage'
import DocumentView from './DocumentView'
import {Modal} from 'react-bootstrap'
import {IoIosClose} from 'react-icons/io'
import {useAuth} from '../../modules/auth'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'
import {useQueryClient} from 'react-query'

const OutpatientPageWrapper: React.FC = () => {
  const auth = useAuth()
  const user = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const {formatMessage: f} = useIntl()
  const queryClient = useQueryClient()
  const claimDetails = location.state as {claimDetails: any}
  const [activeTab, setActiveTab] = useState<'pengesahan' | 'dataPasien' | 'documents'>(
    'pengesahan'
  )
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [remark, setRemark] = useState('')
  const [showRemarkError, setShowRemarkError] = useState(false)
  const [isConfirmCancel, setIsConfirmCancel] = useState(false)
  const [validateBilling, setValidateBilling] = useState(false)
  const [isSaveClaim, setIsSaveClaim] = useState(false)
  const outpatientPageRef = useRef<{
    handleSubmit: (e: React.FormEvent, type: 'save' | 'submit') => Promise<void>
  }>(null)
  const [formData, setFormData] = useState<any>({
    diagnosis: '',
    diagnosis2: '',
    diagnosis3: '',
    diagnosis4: '',
    doctor: '',
    prescription: '',
    department: '',
    notes: '',
    specialTerms: '',
    costs: {},
    excess: {},
    totalBiaya: 0,
    supportingDiagnosis: Array(4).fill(''),
    selectedSupportingIcds: Array(4).fill(null),
  })

  if (!claimDetails?.claimDetails?.claim) {
    return <div>No claim details available</div>
  }

  const handleFormDataChange = (newData: any) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
    }))
  }

  const handleValidateBilling = (isValidateBilling: boolean) => {
    setValidateBilling(isValidateBilling)
  }

  const updateClaimStatus = async (claimNumber: string, remark: string) => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimNumber,
      status: 'Void',
      username: user.currentUser?.email,
      source: 'Provider',
      remarkRejectVoid: remark,
    }
    const headers = {
      Authorization: `Bearer ${auth?.currentUser?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    try {
      const response = await axios.post(apiUrl, payload, {headers})

      if (!response.data.isSuccess) {
        throw new Error('Failed to submit IGL Request')
      }

      // Invalidate and refetch claims queries to update the UI
      queryClient.invalidateQueries(['claims'])
      queryClient.invalidateQueries(['myTurnTotal'])

      toast.success('Update claim status successfully!', {
        position: 'bottom-right',
        autoClose: 3000,
      })

      // Refetch data after successful update
      setIsLoading(true)
      navigate('/claims')
    } catch (error) {
      console.error('Error updating claim status:', error)
      toast.error('Failed to update claim status', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  const handleCancelClick = () => {
    setShowCancelModal(true)
  }

  const handleModalClose = () => {
    setShowCancelModal(false)
    setRemark('')
    setIsConfirmCancel(false)
  }

  const handleConfirmCancel = () => {
    if (!remark.trim()) {
      setShowRemarkError(true)
      return
    }
    updateClaimStatus(claimDetails?.claimDetails?.claim?.claimNumber, remark)
    handleModalClose()
    setRemark('')
    setShowRemarkError(false)
  }

  const handleSaveClaim = (isSaveClaim: boolean) => {
    setIsSaveClaim(isSaveClaim)
  }

  const handleSubmit = async (e: React.FormEvent, type: 'save' | 'submit') => {
    e.preventDefault()
    if (outpatientPageRef.current) {
      // if (formData.totalBiaya === 0 && type === 'submit') {
      // if (formData.totalBiaya === 0 && type === 'submit') {
      //   toast.error('Total biaya tidak boleh 0, silahkan isi biaya komponen dibawah ini', {
      //     position: 'top-right',
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //   })
      //   return
      // } else if (formData.totalBiaya !== 0 && type === 'submit') {
      //   setShowConfirmation(true)
      // }

      if (type === 'submit') {
        setShowConfirmation(true)
      }
      try {
        console.log('OutpatientPageWrapper - Calling child handleSubmit')

        if (showConfirmation || type === 'save') {
          await outpatientPageRef.current.handleSubmit(e, type)
          console.log('OutpatientPageWrapper - Child handleSubmit completed')
        }

        if (type === 'save' && isSaveClaim) {
          toast.success('Data berhasil disimpan!', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          })
        }
      } catch (error: any) {
        console.error('Error in OutpatientPageWrapper handleSubmit:', error)
        setShowConfirmation(false)
        toast.error(error.message || 'Terjadi kesalahan saat menyimpan data', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        })
      }
    } else {
      console.error('OutpatientPageWrapper - outpatientPageRef.current is null')
    }
  }

  const isEditable = ['Pre-Registered', 'Registered'].includes(
    claimDetails?.claimDetails?.claim?.status || ''
  )

  return (
    <>
      {/* <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      /> */}

      <div className='container'>
        {/* Header Section */}
        <div
          className='flex justify-between items-center mb-4'
          style={{display: 'flex', justifyContent: 'space-between'}}
        >
          {/* Left: Card Number and Label */}
          <div className='text-gray-500 flex items-center'>
            <span className='font-large text-lg text-black'>
              {claimDetails?.claimDetails?.claim?.claimNumber || 'N/A'}
            </span>
            <span
              className='ml-6 text-sm text-gray-700 bg-gray-200 py-1 px-3 rounded'
              style={{marginLeft: '10px'}}
            >
              {f({id: 'CLAIM.OUTPATIENT.TITLE'})}
            </span>
          </div>
          {activeTab === 'pengesahan' && isEditable && (
            <div className='flex justify-end space-x-2' style={{display: 'flex', gap: '15px'}}>
              <button className='btn btn-danger cursor-pointer' onClick={handleCancelClick}>
                {f({id: 'CLAIM.OUTPATIENT.VOID'})}
              </button>
              <button
                type='button'
                className='btn btn-secondary'
                onClick={(e) => handleSubmit(e, 'save')}
                disabled={!validateBilling}
              >
                {f({id: 'CLAIM.OUTPATIENT.SAVE'})}
                {/* remove validasi catatan & ketentuan khusus */}
              </button>
              <button
                type='button'
                className='btn btn-primary'
                onClick={(e) => handleSubmit(e, 'submit')}
                disabled={!validateBilling}
              >
                {f({id: 'CLAIM.OUTPATIENT.SEND'})}
              </button>
            </div>
          )}
        </div>

        <div className='tabs'>
          <button
            className={`tab ${activeTab === 'pengesahan' ? 'active' : ''}`}
            onClick={() => setActiveTab('pengesahan')}
          >
            {f({id: 'CLAIM.OUTPATIENT.APPROVAL'})}
          </button>
          <button
            className={`tab ${activeTab === 'dataPasien' ? 'active' : ''}`}
            onClick={() => setActiveTab('dataPasien')}
          >
            {f({id: 'CLAIM.OUTPATIENT.PATIENT_DATA'})}
          </button>
          {(claimDetails?.claimDetails?.claim?.status === 'FGL Released' ||
            claimDetails?.claimDetails?.claim?.status === 'Claim Verification') && (
            <button
              className={`tab ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => setActiveTab('documents')}
            >
              {f({id: 'CLAIM.OUTPATIENT.DOCUMENTS'})}
            </button>
          )}
        </div>

        <div className='tab-content'>
          {activeTab === 'pengesahan' && (
            <OutpatientPage
              ref={outpatientPageRef}
              onSubmit={handleSubmit}
              claimDetails={claimDetails?.claimDetails}
              formData={formData}
              onFormDataChange={handleFormDataChange}
              setShowConfirmation={setShowConfirmation}
              isValidateBilling={validateBilling}
              handleValidateBilling={handleValidateBilling}
              setIsSaveClaim={handleSaveClaim}
            />
          )}
          {activeTab === 'dataPasien' && (
            <PatientPage
              claimDetails={claimDetails?.claimDetails}
              formData={formData}
              onFormDataChange={handleFormDataChange}
            />
          )}
          {activeTab === 'documents' &&
            (claimDetails?.claimDetails?.claim?.status === 'FGL Released' ||
              claimDetails?.claimDetails?.claim?.status === 'Claim Verification') && (
              <DocumentView claimDetails={claimDetails} />
            )}
        </div>

        {/* Confirmation Modal */}
        {showConfirmation && (
          <div className='confirmation-modal'>
            <div className='modal-content-confirmation'>
              <h3>{f({id: 'CLAIM.OUTPATIENT.MODAL_CONFIRMATION_TITLE'})}</h3>
              <p>{f({id: 'CLAIM.OUTPATIENT.MODAL_CONFIRMATION_DESCRIPTION'})}</p>
              <div className='modal-buttons-confirmation'>
                <button className='btn btn-secondary' onClick={() => setShowConfirmation(false)}>
                  {f({id: 'CLAIM.OUTPATIENT.MODAL_CANCEL'})}
                </button>
                <button
                  className='btn btn-primary'
                  onClick={(e) => {
                    setShowConfirmation(false)
                    handleSubmit(e, 'submit')
                  }}
                  disabled={isLoading}
                >
                  {isLoading
                    ? f({id: 'CLAIM.OUTPATIENT.MODAL_LOADING'})
                    : f({id: 'CLAIM.OUTPATIENT.MODAL_CONFIRM'})}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Metronic Cancel Confirmation Modal */}
        <Modal
          id='kt_modal_cancel_claim'
          show={showCancelModal}
          onHide={handleModalClose}
          aria-hidden='true'
          dialogClassName='modal-dialog modal-dialog-centered'
          contentClassName='modal-content rounded'
        >
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div
              className='btn btn-sm btn-icon btn-active-color-primary'
              onClick={handleModalClose}
            >
              <IoIosClose size={24} />
            </div>
          </div>

          <div className='modal-body scroll-y px-10 px-lg-15 pt-0 pb-15'>
            <div className='mb-13 text-center'>
              <h1 className='mb-3'>{f({id: 'CLAIM.OUTPATIENT.MODAL_VOID_TITLE'})}</h1>
            </div>

            <div className='d-flex flex-column mb-8'>
              <div className='text-center mb-5'>
                <p className='text-gray-800 fs-6 fw-semibold'>
                  {/* Are you sure you want to void claim{' '}
                  {claimDetails?.claimDetails?.claim?.claimNumber} on behalf of{' '}
                  {claimDetails?.claimDetails?.claim?.memberName}? */}

                  {f(
                    {id: 'CLAIM.OUTPATIENT.MODAL_VOID_DESCRIPTION'},
                    {
                      claimNumber: claimDetails?.claimDetails?.claim?.claimNumber,
                      memberName: claimDetails?.claimDetails?.claim?.memberName,
                    }
                  )}
                  {/* {intl.formatMessage(
                  {id: 'DASHBOARD.MODAL_DESCRIPTION'},
                  {
                    claimNumber: data?.claimNumber,
                    memberName: data?.memberName,
                  }
                )} */}
                </p>
              </div>

              {isConfirmCancel && (
                <div className='form-group'>
                  <label className='required fw-semibold fs-6 mb-2'>
                    {f({id: 'CLAIM.OUTPATIENT.MODAL_VOID_REMARK'})}
                  </label>
                  <textarea
                    className={`form-control ${showRemarkError ? 'is-invalid' : ''}`}
                    rows={3}
                    value={remark}
                    onChange={(e) => {
                      setRemark(e.target.value)
                      setShowRemarkError(false)
                    }}
                  />
                  {showRemarkError && (
                    <div className='invalid-feedback'>
                      {f({id: 'CLAIM.OUTPATIENT.MODAL_VOID_REMARK_REQUIRED'})}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className='d-flex flex-center flex-row-fluid pt-12'>
              <button type='reset' className='btn btn-light me-3' onClick={handleModalClose}>
                {f({id: 'CLAIM.OUTPATIENT.MODAL_CANCEL'})}
              </button>

              {!isConfirmCancel && (
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => setIsConfirmCancel(true)}
                >
                  {f({id: 'CLAIM.OUTPATIENT.MODAL_CONFIRM'})}
                </button>
              )}

              {isConfirmCancel && (
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleConfirmCancel}
                  disabled={!remark.trim()}
                >
                  {f({id: 'CLAIM.OUTPATIENT.MODAL_SUBMIT'})}
                </button>
              )}
            </div>
          </div>
        </Modal>

        <style>{`
          .tabs {
            display: flex;
            border-bottom: 1px solid #e1e1e1;
            margin-bottom: 16px;
          }
          .tab {
            padding: 12px 16px;
            cursor: pointer;
            background: transparent;
            border: none;
            font-size: 16px;
            color: #6d7194;
          }
          .tab.active {
            border-bottom: 2px solid #0094a2;
            color: #0094a2;
            font-weight: bold;
          }
          .tab-content {
            padding: 16px;
            background: #f9f9f9;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          .btn-simpan, .btn-kirim {
            padding: 8px 12px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            color: white;
            background-color: #0094a2; /* Change this color as needed */
            font-size: 14px;
          }
          .btn-kirim {
            background-color: #007bff; /* Different color for Kirim button */
          }
          .btn-simpan:hover, .btn-kirim:hover {
            opacity: 0.8; /* Slightly change opacity on hover */
          }

          /* Modal styles */
          .confirmation-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1000;
          }
          
          .modal-content-confirmation {
            background-color: white;
            padding: 24px;
            border-radius: 8px;
            width: 400px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }
          
          .modal-content-confirmation h3 {
            margin-top: 0;
            color: #0094a2;
          }
          
          .modal-buttons-confirmation {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 24px;
          }
        `}</style>
      </div>
    </>
  )
}

export default OutpatientPageWrapper
